import React from "react";

const NoData = (props) => {
  return (
    <div className="nodata">
      <h1 className="nodataheading">{props?.noDataText}</h1>
    </div>
  );
};

export default NoData;
